import {useEffect, useState} from "react";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import BackButton from "../../components/BackButton";
import {useNavigate} from "react-router-dom";
import {useLang} from "../../context/LanguageContext";
import {useAuth} from "../../context/AuthContext";
import {trackRegisterButtonClick} from "../../utils/tracking";

const ForgotPasswordPage = () => {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);
    const { currentUser } = useAuth();
    const navigate = useNavigate();
    const { t } = useLang();

    useEffect(() => {
        if(currentUser){
            navigate('/account');
        }
    }, [currentUser, navigate]);

    const handleReset = async (e) => {
        e.preventDefault();
        setMessage(null);
        setError(null);

        const auth = getAuth();

        try {
            await sendPasswordResetEmail(auth, email);
            setMessage(t("txt.resetPasswordSuccess"));
            setEmail("");
            setTimeout(() => {
                setMessage(null);
            }, 5000);
        } catch (err) {
            setError(t("txt.resetPasswordError"));
            setEmail("");
            setTimeout(() => {
                setError(null);
            }, 5000);
        }
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 relative">
            <BackButton onClick={() => navigate('/')}/>

            <h1 className="mb-4 text-xl font-bold">{t('txt.resetPasswordTitle')}</h1>
            <div className="w-64 mb-4">
                <input
                    type="email"
                    placeholder={t('txt.email')}
                    className="w-full mb-2 px-3 py-2 border rounded"
                    value={email}
                    required
                    onChange={(e) => setEmail(e.target.value)}
                />
            </div>
            <div className="w-64 mb-4">
                {message && <p style={{color: "green", marginTop: "10px"}}>{message}</p>}
                {error && <p style={{color: "red", marginTop: "10px"}}>{error}</p>}
            </div>

            <div className="flex flex-col space-y-2 w-64 mb-6">
                <button
                    onClick={handleReset}
                    className="px-4 py-2 bg-[#34495e] text-white rounded mb-4"
                >
                    {t('btn.forgotPassword')}
                </button>
                <button
                    onClick={() => navigate('/login')}
                    className="px-4 py-2 bg-[#34495e] text-white rounded"
                >
                    {t('btn.login')}
                </button>
                <button
                    onClick={() => {
                        trackRegisterButtonClick();
                        navigate('/register');
                    }}
                    className="px-4 py-2 bg-[#27ae60] text-white rounded"
                >
                    {t('btn.register')}
                </button>
            </div>
        </div>
    );
};

export default ForgotPasswordPage;